import { Formik, Field, Form, ErrorMessage } from "formik";
import "./join-us.css";
import { useSecondViewHook } from "./useSecondViewHook";

const SecondView = ({ handleNext, formData, setData }) => {
  const {
    showPassword,
    showConfirmPassword,
    setShowPassword,
    setShowConfirmPassword,
    validationSchema,
    togglePasswordVisibility,
    toggleConfirmPasswordVisibility,
    handleNavigate,
  } = useSecondViewHook();

  return (
    <div className="container h-100 my-5">
      <div className="row">
        <div className="col-md-12">
          <legend className="text-center header text-success mb-3">
            <h4>GENERAL INFORMATION</h4>
          </legend>
          <Formik
            initialValues={{
              member_id: formData.member_id,
              token: formData.token,
              firstName: formData.firstName,
              lastName: formData.lastName,
              password: formData.password,
              confirmPassword: formData.confirmPassword || "",
              email: formData.email,
              confirmEmail: formData.confirmEmail,
              phone: formData.phone,
              address: "",
              country: "",
              city: "",
              zip: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              setData(values);
              handleNext(values);
            }}
          >
            {({ errors, touched }) => (
              <Form>
                <div className="row mb-3">
                  {/* First Name */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="firstName" className="required mb-2">
                        First Name: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-user bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="firstName"
                          name="firstName"
                          type="text"
                          placeholder="First Name"
                          className={`form-control ${
                            errors.firstName && touched.firstName
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="lastName" className="required mb-2">
                        Last Name: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-user bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="lastName"
                          name="lastName"
                          type="text"
                          placeholder="Last Name"
                          className={`form-control ${
                            errors.lastName && touched.lastName
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  {/* Password */}
                  <div className="col-md-6">
                    <div className="form-group position-relative">
                      <label htmlFor="password" className="required mb-2">
                        Password: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-lock bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          placeholder="Password"
                          className={`form-control ${
                            errors.password && touched.password
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="btn-eye"
                      >
                        <i
                          className={`fa ${
                            showPassword ? "fa-eye-slash" : "fa-eye"
                          }`}
                        ></i>
                      </button>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group position-relative">
                      <label
                        htmlFor="confirmPassword"
                        className="required mb-2"
                      >
                        Confirm Password:{" "}
                        <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-lock bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="confirmPassword"
                          name="confirmPassword"
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder="Confirm Password"
                          className={`form-control ${
                            errors.confirmPassword && touched.confirmPassword
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <button
                        type="button"
                        onClick={toggleConfirmPasswordVisibility}
                        className="btn-eye"
                      >
                        <i
                          className={`fa ${
                            showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                          }`}
                        ></i>
                      </button>
                      <ErrorMessage
                        name="confirmPassword"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  {/* Phone Number */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="phone" className="required mb-2">
                        Contact Number:{" "}
                        <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-phone bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="phone"
                          name="phone"
                          type="text"
                          placeholder="Phone/Cell"
                          className={`form-control ${
                            errors.phone && touched.phone ? "field-error" : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  {/* Address */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="address" className="required mb-2">
                        Address: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-address-book bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="address"
                          name="address"
                          type="text"
                          placeholder="Address"
                          className={`form-control ${
                            errors.address && touched.address
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  {/* Country */}
                  <div className="col-md-5">
                    <div className="form-group">
                      <label htmlFor="country" className="required mb-2">
                        Country: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-globe bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="country"
                          name="country"
                          type="text"
                          placeholder="Country"
                          className={`form-control ${
                            errors.country && touched.country
                              ? "field-error"
                              : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="country"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>

                  {/* City */}
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="city" className="required mb-2">
                        City: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-globe bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="city"
                          name="city"
                          type="text"
                          placeholder="City"
                          className={`form-control ${
                            errors.city && touched.city ? "field-error" : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="city"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>

                  {/* Zip */}
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="zip" className="required mb-2">
                        Zip: <span className="required-icon"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text p-spacing">
                            <i className="fa fa-map-pin bigicon"></i>
                          </span>
                        </div>
                        <Field
                          id="zip"
                          name="zip"
                          type="text"
                          placeholder="Zip"
                          className={`form-control ${
                            errors.zip && touched.zip ? "field-error" : ""
                          }`}
                        />
                      </div>
                      <ErrorMessage
                        name="zip"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="row my-4">
                  <div className="col-md-7">
                    <button
                      type="submit"
                      className="btn btn-success py-2 px-4 btn-lg me-3"
                    >
                      Update and Proceed
                    </button>
                    <button
                      className="btn btn-warning py-2 px-4 btn-lg me-2 mt-1"
                      type="reset"
                    >
                      Reset
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger py-2 px-4 mx-2 mt-1 btn-lg"
                      onClick={handleNavigate}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default SecondView;
